var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.dropdownClasses,style:(_vm.dropdownStyles)},[_c('div',{staticClass:"dropdown-content"},[_vm._t("default",null,null,this)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }